"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocale = void 0;
const locale_types_1 = require("./locale-types");
const react_1 = require("react");
const cs_1 = __importDefault(require("date-fns/locale/cs"));
const en_GB_1 = __importDefault(require("date-fns/locale/en-GB"));
const de_1 = __importDefault(require("date-fns/locale/de"));
const sk_1 = __importDefault(require("date-fns/locale/sk"));
const fr_1 = __importDefault(require("date-fns/locale/fr"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const locale_api_1 = require("./locale-api");
const local_storage_hook_1 = require("../../utils/local-storage-hook");
function useLocale(props) {
    const [localeName, setLocaleName] = local_storage_hook_1.useLocalStorage('localeName', props.defaultLocale);
    const [messages, setMessages] = react_1.useState({});
    const switchLocale = event_callback_hook_1.useEventCallback(async (localeName) => {
        setLocaleName(localeName);
    });
    const loadTranslations = event_callback_hook_1.useEventCallback(async (lang) => {
        if (props.messages && props.messages[lang]) {
            setMessages(props.messages[lang]);
        }
        else if (props.translationsUrl) {
            const fetch = locale_api_1.callLoadTranslations(props.translationsUrl, lang);
            const response = await fetch.response;
            if (response.status === 200) {
                const messages = await response.json();
                setMessages(messages);
            }
            else {
                setMessages({});
            }
        }
    });
    const refreshTranslations = event_callback_hook_1.useEventCallback(async () => {
        await loadTranslations(localeMap[localeName].easLanguage);
    });
    react_1.useEffect(() => {
        loadTranslations(localeMap[localeName].easLanguage);
    }, [loadTranslations, localeName]);
    const context = react_1.useMemo(() => ({
        locale: localeMap[localeName],
        messages,
        switchLocale,
        refresh: refreshTranslations,
    }), [localeName, messages, switchLocale, refreshTranslations]);
    return { context };
}
exports.useLocale = useLocale;
const localeMap = {
    [locale_types_1.LocaleName.cs]: {
        name: 'cs',
        dateFormat: 'dd.MM.yyyy',
        dateTimeFormat: 'dd.MM.yyyy HH:mm:ss',
        timeFormat: 'HH:mm:ss',
        dateFnsLocale: cs_1.default,
        intlLocale: 'cs',
        easLanguage: 'CZECH',
    },
    [locale_types_1.LocaleName.en]: {
        name: 'en',
        dateFormat: 'dd/MM/yyyy',
        dateTimeFormat: 'dd/MM/yyyy HH:mm:ss',
        timeFormat: 'HH:mm:ss',
        dateFnsLocale: en_GB_1.default,
        intlLocale: 'en',
        easLanguage: 'ENGLISH',
    },
    [locale_types_1.LocaleName.de]: {
        name: 'de',
        dateFormat: 'dd.MM.yyyy',
        dateTimeFormat: 'dd.MM.yyyy HH:mm:ss',
        timeFormat: 'HH:mm:ss',
        dateFnsLocale: de_1.default,
        intlLocale: 'de',
        easLanguage: 'GERMAN',
    },
    [locale_types_1.LocaleName.sk]: {
        name: 'sk',
        dateFormat: 'dd.MM.yyyy',
        dateTimeFormat: 'dd.MM.yyyy HH:mm:ss',
        timeFormat: 'HH:mm:ss',
        dateFnsLocale: sk_1.default,
        intlLocale: 'sk',
        easLanguage: 'SLOVAK',
    },
    [locale_types_1.LocaleName.fr]: {
        name: 'fr',
        dateFormat: 'dd/MM/yyyy',
        dateTimeFormat: 'dd/MM/yyyy HH:mm:ss',
        timeFormat: 'HH:mm:ss',
        dateFnsLocale: fr_1.default,
        intlLocale: 'fr',
        easLanguage: 'FRENCH',
    },
};
//# sourceMappingURL=locale-hook.js.map